export const MAX_LENGTH = 35

export const splitKeys = (keys: string[]): string[][] => {
	if (keys.length > MAX_LENGTH) {
		// Remove duplicates
		const clonedKeys = [...new Set(keys)]
		const splittedKeys: string[][] = []
		while (clonedKeys.length > 0) {
			splittedKeys.push(clonedKeys.splice(0, MAX_LENGTH))
		}

		return splittedKeys
	}
	return [keys]
}
